/**
 * Geo Detection & Localization Utilities
 * Handles IP detection, market determination, and preference storage
 */

window.GeoUtils = {
  async getDetectedCountry() {
    const cached = sessionStorage.getItem("detected_country");
    if (cached && cached !== "null") {
      return cached;
    }

    try {
      const response = await fetch("/browsing_context_suggestions.json");
      if (!response.ok) {
        throw new Error(`Shopify geo API error: ${response.status}`);
      }

      const data = await response.json();
      const countryCode = data?.detected_values?.country?.handle;

      if (!countryCode) {
        throw new Error("Country code not found in response");
      }

      const upper = countryCode.toUpperCase();
      sessionStorage.setItem("detected_country", upper);
      return upper;
    } catch (error) {
      console.error("Failed to detect country:", error);
      if (window.Sentry) {
        Sentry.captureException(error);
      }
      return null;
    }
  },

  getMarketFromCountry(countryCode) {
    const US_MARKET = ["US", "CA", "AU", "NZ"];
    return US_MARKET.includes(countryCode) ? "us" : "eu";
  },

  getCurrentMarket() {
    const hostname = window.location.hostname;
    // us.momenterie.com = US market
    // momenterie.com = EU market
    return hostname.startsWith("us.") ? "us" : "eu";
  },
  getStoredMarketPreference() {
    return localStorage.getItem("pref_store");
  },
  setMarketPreference(market) {
    localStorage.setItem("pref_store", market);
  },
  getStoredLanguagePreference() {
    return localStorage.getItem("pref_lang");
  },
  setLanguagePreference(lang) {
    localStorage.setItem("pref_lang", lang);
  },
};

window.detectedCountryPromise = window.GeoUtils.getDetectedCountry();
